module.exports = __webpack_public_path__ + "ab2bb3d22e94750cd943c169bf6b6ba8.pdf";